// extracted by mini-css-extract-plugin
export default {"continer":"CustomersRecommend_continer__yo849","title":"CustomersRecommend_title__cv0Jn"};